import { render } from "./TakeATour.vue?vue&type=template&id=14385489&scoped=true"
import script from "./TakeATour.vue?vue&type=script&lang=js"
export * from "./TakeATour.vue?vue&type=script&lang=js"

import "./TakeATour.vue?vue&type=style&index=0&id=14385489&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14385489"]])

export default __exports__